<template>
  <div class="media">
    <label class="form__upload-container" for="image">
      SUBIR IMAGEN
      <input type="file" class="form__upload" multiple accept=".png,.jpg,.jpeg,.gif" name="image" id="image" @change="uploadMedia">
    </label>
    <div class="media__content" v-if="media">
      <label :for="item.id" class="media__element" v-for="(item, index) in media.images" :key="index">
        <input type="radio" name="image" :id="item.id" class="media__radio" v-model="mediaElement" :value="item">
        <img :src="config.statics.url + item.sizes.thumb" :alt="item.name" class="media__image">
        <span class="media__name" v-text="item.name"></span>
      </label>
    </div>
    <button v-if="mediaElement" @click.prevent="selectImage" class="btn btn__action btn--small">Utilizar Imagen</button>
    <button v-if="mediaElement" class="btn btn__caution btn--small" @click.prevent="deleteImage">Borrar imagen</button>
    <confirmation v-if="confirm" @cancel="confirm = false"></confirmation>
  </div>
</template>

<script>
import httpService from '@/core/api/request'
import confirmation from '@/components/layout/confirmation'
import {config} from '@/core/config/base'
export default {
  mixins: [httpService],
  components: {confirmation},
  data: function () {
    return {
      config: config,
      media: null,
      mediaElement: null,
      confirm: false
    }
  },
  created: function () {
    this.getMedia()
  },
  mounted: function () {
    this.$on('continue', () => {
      this.confirm = false
      this.proccedToDelete()
    })
  },
  methods: {
    selectImage: function () {
      if (this.$route.name === 'ckMedia') {
        window.opener.CKEDITOR.tools.callFunction( 0, config.statics.url + this.mediaElement.sizes.big)
        window.close()
      } else {
        this.$parent.$emit('image', {
          'image': this.mediaElement,
          'url': config.statics.url
        })
      }
    },
    getMedia: function () {
      let httpRequest = {
        params: '',
        module: 'media'
      }
      this.get(httpRequest)
        .then(
          media => {
            media.images.reverse()
            this.media = media
          }
        ).catch(
          error => {
            this.$store.commit('notificate', {
              title: 'SIN RESULTADOS',
              text: 'No se encontraron imágenes para mostrar, puede subir nuevas imágenes desde su dispositivo',
              type: 'warn'
            })
          }
        )
    },
    uploadMedia: function (e) {
      let httpRequest = {
        params: '',
        module: 'media'
      }
      this.upload(e, httpRequest)
        .then(
          response => {
            this.getMedia()
          }
        )
    },
    deleteImage: function () {
      this.confirm = true
    },
    proccedToDelete: function () {
      let httpRequest = {
        params: '',
        module: 'media'
      }
      this.delete(this.mediaElement.id, httpRequest)
        .then(
          response => {
            this.getMedia()
            this.$store.commit('notificate', {
              title: 'IMAGEN BORRADA',
              text: 'La imagen fue borrada correctamente',
              type: 'success'
            })
          }
        ).catch(
          error => {
            this.$store.commit('notificate', {
              title: 'IMAGEN NO BORRADA',
              text: 'No se ha podido borrar la imagen, por favor intente de nuevo',
              type: 'warn'
            })
          }
        )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/media/files.vue